import React from 'react'
import styles from './styles.module.scss'

type SizeChartTabButtonProps = {
  tabName: string
  tabValue: string | number
  selectedTab: string
  handleOnClick: () => void
}

const SizeChartTabButton = ({
  tabName,
  tabValue,
  selectedTab,
  handleOnClick
}: SizeChartTabButtonProps) => {
  return (
    <button
      onClick={handleOnClick}
      className={styles.sizeChart__tab}
      data-selected={
        selectedTab.toLowerCase() === tabName.toLowerCase() ? 'true' : 'false'
      }
    >
      {tabValue}
    </button>
  )
}

type SizeChartTabsProps = {
  tabs: Record<string, string | number>
  selectedTab: string
  setSelectedTab: (tab: string) => void
  typeTab?: boolean
  desktop?: boolean
}

const SizeChartTabs = ({
  tabs,
  selectedTab,
  setSelectedTab,
  typeTab = false,
  desktop = false
}: SizeChartTabsProps) => {
  return (
    <div
      className={`${styles.sizeChart__tabs} ${typeTab ? styles.typeTabs : ''} ${
        desktop ? styles.desktopTypeTabs : ''
      }`}
    >
      {Object.keys(tabs).map((tabName, i) => {
        return (
          <SizeChartTabButton
            key={tabName}
            tabName={tabName}
            tabValue={tabs[tabName]}
            selectedTab={selectedTab}
            handleOnClick={() => setSelectedTab(tabName)}
          />
        )
      })}
    </div>
  )
}

export default SizeChartTabs
